import NavBar from '@/components/Nav.vue';

export default {
    name: 'EntityDetailPage',
    components: {
        NavBar
    },
}